<template>
  <aw-spring :desktop-size="10">
    <aw-breadcrumb-version2 :class="$style.breadcrumb" />
    <aw-cms-white-card
      mobile-negative-margin
      :class="$style.card"
    >
      <template #head>
        <lv-heading
          level="1"
          tag="h1"
          version2
        >
          {{ $awt('aw.pages.career.title') }}
        </lv-heading>
      </template>
      <aw-career-menu>
        <aw-aggregated-page-highlighted-carousel
          page-type="career_news"
          :title-line-clamp="3"
          :title-attrs="{
            tag: 'h1',
            level: '2'
          }"
          :button-items="carouselButtonItems"
          :carousel-type="SCT_FULL_CAROUSEL_V3_TEXT_ON_IMAGE"
          :show-separator="false"
        />
        <div :class="$style.newsHeading">
          <lv-heading
            level="2"
            tag="h2"
            version2
            :class="$style.title"
          >
            {{ $awt('aw.pages.career.news.news_list') }}
          </lv-heading>
        </div>
        <aw-aggregated-pages-cards
          :params="{}"
          page-type="career_news"
          vertical-only
          :class="$style.cardList"
        />
      </aw-career-menu>
    </aw-cms-white-card>
  </aw-spring>
</template>

<script setup lang="ts">
  import { provide } from 'vue';
  import AwBreadcrumbVersion2 from '~~/common/components/Common/AwBreadcrumbVersion2.vue';
  import AwCmsWhiteCard from '~~/common/components/AwCmsWhiteCard.vue';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import AwSpring from '~~/common/components/AwSpring.vue';
  import AwAggregatedPageHighlightedCarousel
    from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageHighlightedCarousel.vue';
  import { useNuxtApp } from 'nuxt/app';
  import { useBreadcrumbStore } from '~~/common/stores/breadcrumb.js';
  import AwCareerMenu from '~~/common/components/AwCareerMenu.vue';
  import AwAggregatedPagesCards from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageCards.vue';
  import { SCT_FULL_CAROUSEL_V3_TEXT_ON_IMAGE } from '~~/common/config/AwStandardTypeConfig';
  import { useContentMenu } from '~~/common/composables/useContentMenu';
  import { useCareerBreadcrumbs } from '~~/common/composables/useCareerBreadcrumbs';
  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });

  const { $awt } = useNuxtApp();

  const carouselButtonItems = [{
    token: 'aw.pages.career.news.highlighted_news.button',
    type: 'primary-light',
    mobileType: 'primary-light',
  }];

  const breadcrumbStore = useBreadcrumbStore();
  const { careerHomeBreadcrumb } = useCareerBreadcrumbs();
  provide('getRowIndexById', () => 0);

  await useContentMenu('career-menu');

  breadcrumbStore.setBreadcrumbs([
    {
      token: $awt('aw.common.category.home'),
      to: '/',
      disabled: false,
    },
    careerHomeBreadcrumb(false),
    {
      token: $awt('aw.pages.career.news.title'),
      to: '/karrier/hirek',
      disabled: true,
    },
  ]);
</script>

<style module lang="scss" rel="stylesheet/scss">
.breadcrumb {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }

  @include mobile(max) {
    padding: 2px 16px;
  }
}

.card {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 60px;
  }

  &List {
    margin-bottom: 44px;
    @include tablet(min) {
      margin-bottom: 40px;
    }
  }
}

.newsHeading {
  margin-bottom: 32px;
}

.title {
  margin-top: 20px !important;
  @include tablet(min) {
    margin-top: 40px !important;
  }
}
</style>
